import React from 'react';
import { Activity, Ban, RefreshCw, ClipboardList } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';

const humanize = (action = '') => action.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());

const iconFor = (action) => {
  if (action === 'institution_suspended') return { Icon: Ban, bg: 'bg-red-100', fg: 'text-red-600' };
  if (action === 'institution_reactivated') return { Icon: RefreshCw, bg: 'bg-green-100', fg: 'text-green-600' };
  return { Icon: ClipboardList, bg: 'bg-slate-200', fg: 'text-slate-600' };
};

const subjectOf = (log) =>
  log.institution_name || log.details?.institution_name || log.details?.item_name || log.details?.suggested_by || null;

const actorOf = (log) => log.performed_by_name || log.admin_name || 'System';

export function ActivityLog({ activityLog }) {
  return (
    <Card data-testid="platform-activity-log">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Activity className="w-5 h-5" />
          Recent Activity
        </CardTitle>
        <CardDescription>Latest platform admin actions</CardDescription>
      </CardHeader>
      <CardContent>
        {activityLog.length > 0 ? (
          <div className="space-y-3">
            {activityLog.map((log) => {
              const { Icon, bg, fg } = iconFor(log.action);
              const subject = subjectOf(log);
              return (
                <div key={log.id} className="flex items-center gap-4 p-3 bg-slate-50 rounded-lg" data-testid={`activity-${log.id}`}>
                  <div className={`p-2 rounded-full ${bg}`}>
                    <Icon className={`w-4 h-4 ${fg}`} />
                  </div>
                  <div className="flex-1">
                    <p className="text-sm font-medium text-slate-900">{humanize(log.action)}</p>
                    <p className="text-xs text-slate-500">
                      {subject ? `${subject} · ` : ''}by {actorOf(log)}
                    </p>
                  </div>
                  <div className="text-xs text-slate-400">
                    {new Date(log.timestamp).toLocaleString()}
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <p className="text-center text-slate-500 py-8">No recent activity</p>
        )}
      </CardContent>
    </Card>
  );
}
